module.exports = __webpack_public_path__ + "static/media/add.953d2292.svg";